// @flow
import React from 'react';
import InfoBox from '@justpark/ui/src/components/InfoBox';
import LandingIcon from './LandingPageIcon';

type Props = {
  hideIcons: boolean,
  triggered: boolean,
  displayAll: boolean,
  reference: any
};

const LandingInfoBoxes = ({
  hideIcons,
  triggered,
  displayAll,
  reference: ref
}: Props) => (
  <div
    className={`c-info__box-container ${
      !displayAll ? 'c-info__box-container--visible' : ''
    }`}
    ref={ref}
  >
    <InfoBox
      icon={
        !hideIcons && triggered ? <LandingIcon iconName="availability" /> : null
      }
    >
      View information on location, price, availability and restrictions for all
      of our parking spaces
    </InfoBox>
    <InfoBox
      icon={
        !hideIcons && triggered ? <LandingIcon iconName="lightning" /> : null
      }
    >
      For total peace of mind, book one of our reservable spaces to guarantee
      your spot in advance, with prices starting at just £3 per day
    </InfoBox>
    <InfoBox
      icon={
        !hideIcons && triggered ? <LandingIcon iconName="pay-card" /> : null
      }
    >
      You can reserve and pay via the JustPark website or app for any space with
      the lightning bolt icon.
    </InfoBox>
  </div>
);

export default LandingInfoBoxes;
